import { render, staticRenderFns } from "./Item3.vue?vue&type=template&id=09d6fe72&scoped=true"
import script from "./Item3.vue?vue&type=script&lang=js"
export * from "./Item3.vue?vue&type=script&lang=js"
import style0 from "./Item3.vue?vue&type=style&index=0&id=09d6fe72&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d6fe72",
  null
  
)

export default component.exports